<template>
    <div v-if="mission" class="small">
        <h6 class="mb-2">Chauffeurs</h6>

        <ul class="list-group mb-2">
            <li v-for="member in mission.members" :key="member.id"
                class="list-group-item d-flex justify-content-between align-items-center">
                <span class="text-break" :title="member.firstName + ' ' + member.lastName">
                    {{ member.firstName }} {{ member.lastName }}
                </span>
                <button v-if="canEdit" class="btn btn-sm btn-outline-danger"
                    @click="removeMember(member)">Supprimer</button>
            </li>
            <li v-if="!mission.members?.length" class="list-group-item text-muted">Aucun chauffeur affecté.</li>
        </ul>

        <div v-if="canEdit" class="mt-2">
            <label class="form-label me-2">Ajouter :</label>
            <MemberSelect @memberChange="addMember" />
        </div>
    </div>
    <div v-else />
</template>

<script>
import MemberSelect from '@/views/Missions/Components/MemberSelect.vue'
import MissionService from '@/services/mission.service'

export default {
    name: 'MembersEditor',
    props: { mission: { type: Object, required: true } },
    components: { MemberSelect },
    emits: ['refresh'],
    computed: {
        canEdit() {
            if (!this.mission) return false;
            const s = this.mission.status;
            return (s === 'PENDING' || s === 'DRAFT') && !this.$isViewer && !this.mission.driverVerified;
        }
    },
    methods: {
        addMember(member) {
            if (!this.canEdit || !member?.id) return;
            MissionService.addMissionMember({ memberId: member.id }, this.mission.id)
                .then(() => this.$emit('refresh'))
                .catch(console.log);
        },
        removeMember(member) {
            if (!this.canEdit || !member?.id) return;
            MissionService.removeMissionMember({ memberId: member.id }, this.mission.id)
                .then(() => this.$emit('refresh'))
                .catch(console.log);
        }
    }
}
</script>
